export default "__VITE_ASSET__BfZapcLi__"